module.exports = __webpack_public_path__ + "~@/assets/img/2_create.41d26a52.png";